import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useEffect, useState } from 'react';
import useViewAccrual from 'src/hooks/useViewAccrual';
const DepartmentsDropdownList = () => {
  const { departmentList, selectedDepartment, setSelectedDepartment } = useViewAccrual();

  const [data, setData] = useState(departmentList);

  const handleDepartmentChange = useCallback(
    (e: DropDownListChangeEvent) => {
      const { value } = e.target;
      setSelectedDepartment(value);
    },
    [setSelectedDepartment]
  );

  useEffect(() => {
    if (departmentList.length > 1) {
      setData(departmentList);
    }
  }, [departmentList]);

  return (
    <div className="flex items-center gap-2 px-2">
      <div>Department: </div>
      <DropDownList
        id="view-drop-down-list"
        style={{ width: 200 }}
        data={data}
        textField="departmentName"
        dataItemKey="departmentId"
        value={selectedDepartment}
        onChange={handleDepartmentChange}
      />
    </div>
  );
};

export default DepartmentsDropdownList;
